import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/custom.css';
import './styles/new_style.css';
import { Provider, useDispatch } from 'react-redux';
import { store } from './store';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import Home from './components/home/Home';
import Dashboard from './components/dashboard/Dashboard';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddCompany from './components/company/AddCompany';
import Mycompany from './components/Mycompany'
import { decryptAndRetrieveData, encryptAndStoreData } from './components/login/encript-decript';
import { useCookies } from 'react-cookie';
import Submenu from './components/Submenu';
import { dropDowns, setcompanydata } from './store/reducers';
import Dynamicroute from './components/Dynamicroute';
import Contact from './components/Contact';
import Detail from './components/Detail';
import Dloader from './components/Dloader';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <MainApp />
        <ToastContainer />
      </BrowserRouter>
    </Provider>
  );
}

function MainApp() {
  const user = decryptAndRetrieveData("isAuth", '123456789')
  const token = localStorage.getItem('accessToken')
  
  let usertype
  if (user && token) {
    const decodedToken = JSON.parse(atob(token.split('.')[1]))
    const user_type = decodedToken['custom:user_type']
    usertype = user_type
  }


  const { route } = useSelector((state) => state.counter);
  const { companydata } = useSelector((state) => state.counter);
  const [loader, setloader] = useState(false)
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const path = localStorage.getItem('path')

  useEffect(() => {
   
    if (user && location.pathname === '/') {
      if(path){
        navigate(path)
      }else{
      navigate('/dashboard');
      }
    }
    if (!user) {

      if (location.pathname === '/dashboard') {
        navigate('/dashboard');
      } else if (location.pathname === '/product-purchase') {
        navigate('/product-purchase');
      }
      else if (location.pathname === '/product-produced') {
        navigate('/product-produced');
      }
      else if (location.pathname === '/contactus') {
        navigate('/contactus');
      }
      else if (location.pathname === '/service') {
        navigate('/service');
      }
      else if (location.pathname === '/equipment') {
        navigate('/equipment');
      }
      else if (location.pathname === '/company/approve' || location.pathname === '/company/reject') {
        // console.log('hi');
        setloader(true)

      }
      else if (location.pathname === '/add-company' || location.pathname === '/my-company') {
        navigate('/');
      }
    }
  }, [user, navigate, location.pathname]);

  

  useEffect(() => {
    if (!user) {
      if (location.pathname === '/detail' && location.state?.route1.lengtgh > 0) {
        navigate('/detail');
      }
    }
  }, [])

  useEffect(() => {
    let logoutTimer;

    if (user) {
      logoutTimer = setTimeout(() => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("isAuth");
        localStorage.removeItem("user");
        navigate('/');
        console.log("Session expired. Logging out...");
      }, 60 * 60 * 1000); // 60 minutes

      return () => clearTimeout(logoutTimer);
    }
  }, [user, navigate]);

  useEffect(() => {
    if (location.pathname === '/product-purchase' || location.pathname === '/product-produced' || location.pathname === '/service' || location.pathname === '/equipment') {
      dispatch(dropDowns()).then((res) => {
        dispatch(setcompanydata(res.payload))
      });
    }
  }, [location.pathname === '/product-purchase', location.pathname === '/product-produced', location.pathname === '/service', location.pathname === '/equipment']);

  return (
    <>
      <Navbar />
      <Routes>
        {!user && (
          <>
            <Route path='/' element={<Home />} />
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/contactus' element={<Contact />} />
            <Route path='/product-purchase' element={<Submenu data={companydata?.payload?.wood_products} title={'Companies That Buy'} />} />
            <Route path='/product-produced' element={<Submenu data={companydata?.payload?.wood_products} title={'Companies That Sell'} />} />
            <Route path='/service' element={<Submenu data={companydata?.payload?.services} title={'Services'} />} />
            <Route path='/equipment' element={<Submenu data={companydata?.payload?.equipments} title={'Equipment'} />} />
            <Route path={'/company-detail'} element={<Detail />} />
            {/* <Route path={`/${route?.payload}`} element={<Dynamicroute />} /> */}
            <Route path={'/detail'} element={<Dynamicroute />} />
            <Route path={'/company/approve/:company_id'} element={<Dloader loader={loader} />} />
            <Route path={'/company/reject/:company_id'} element={<Dloader loader={loader} />} />
          </>
        )}
        {(user) && (
          <>
          <Route path='/' element={<Home />} />
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/add-company' element={<AddCompany />} />
            <Route path='/contactus' element={<Contact />} />
            <Route path='/my-company' element={<Mycompany />} />
            <Route path='/product-purchase' element={<Submenu data={companydata?.payload?.wood_products} title={'Companies That Buy'} />} />
            <Route path='/product-produced' element={<Submenu data={companydata?.payload?.wood_products} title={'Companies That Sell'} />} />
            <Route path='/service' element={<Submenu data={companydata?.payload?.services} title={'Services'} />} />
            <Route path='/equipment' element={<Submenu data={companydata?.payload?.equipments} title={'Equipment'} />} />
            <Route path={'/company-detail'} element={<Detail />} />
            {/* <Route path={`/${route?.payload}`} element={<Dynamicroute />} /> */}
            <Route path={'/detail'} element={<Dynamicroute />} />
            <Route path={'/company/approve/:company_id'} element={<Dloader loader={loader} />} />
            <Route path={'/company/reject/:company_id'} element={<Dloader loader={loader} />} />
          </>
        )}
      </Routes>

      <Footer />
    </>
  );
}

export default App;
